<template>
  <div>
    <v-combobox label="ASIN" item-text="asin" item-value="asin" clearable
                v-if="allowNew" :return-object="false" :items="items" v-model="selectedAsin" :rules="rules" @click:clear="clear">
      <template v-slot:item="{ item }">
        <v-list-item-avatar>
          <v-img :src="item.imageUrl"/>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{ item.asin }}</v-list-item-title>
        </v-list-item-content>
      </template>
    </v-combobox>
    <v-autocomplete label="ASIN" item-text="asin" item-value="asin" clearable
                    v-else :items="items" v-model="selectedAsin" :rules="rules" @click:clear="clear">
      <template v-slot:selection="{ item }">
        <v-avatar width="25" height="25">
          <v-img width="25" height="25" contain :alt="item.asin" :src="item.imageUrl"/>
        </v-avatar>
        {{ item.asin }}
      </template>
      <template v-slot:item="{ item }">
        <v-list-item-avatar>
          <v-img :src="item.imageUrl"/>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{ item.asin }}</v-list-item-title>
        </v-list-item-content>
      </template>
    </v-autocomplete>
  </div>

</template>

<script>
export default {
  name: "AsinSelector",
  props: {
    value: [Object, String],
    rules: Array,
    allowNew: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    selectedAsin: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val instanceof Object ? val.asin : val);
      }
    }
  },
  data() {
    return {
      loading: false,
      items: [],
    }
  }, methods: {
    getData() {
      this.loading = true;
      this.$axios.get("/keyword/asins").then(
          response => {
            this.loading = false;
            this.items = response.data;
          }
      );
    },
    clear() {
      this.selectedAsin = null;
    }
  },
  mounted() {
    this.getData();
  }
}
</script>

<style scoped>

</style>